module.exports = __webpack_public_path__ + "img/Report.604a4b57.svg";